export const navigation = [
  { label: "Создать", path: "/create", icon: "✦" },
  { label: "Генерации", path: "/generations", icon: "◫" },
  { label: "Галерея", path: "/gallery", icon: "▦" },
  { label: "Клиенты", path: "/clients", icon: "◎" },
  { label: "Шаблоны", path: "/templates", icon: "◇" },
  { label: "Площадки", path: "/platforms", icon: "⌁" },
  { label: "Использование", path: "/usage", icon: "◔" },
  { label: "Настройки", path: "/settings", icon: "⚙" },
] as const;
